import { Card } from "@chakra-ui/react";
import styles from "./featurecard.module.scss";
import { FeatureData } from "../../sections/features";
import OptimizedImage from "../common/OptimizedImage";

type FeatureCardProp = {
  data: FeatureData;
};

const FeatureCard: React.FC<FeatureCardProp> = ({ data }) => {
  return (
    <Card.Root className={styles.cardContainer}>
      <OptimizedImage
        src={data.image}
        alt={`image representing ${data.title}`}
        className={styles.cardImage}
        style={{ objectFit: "contain" }}
      />
      <Card.Body className={styles.cardDescription}>
        <h3 className={styles.cardSubtitle}>{data.title}</h3>
        <p className={styles.cardText}>{data.description}</p>
      </Card.Body>
    </Card.Root>
  );
};

export default FeatureCard;
